/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorDcbAliases {
  BUTTON_SELECT_LOCATOR = 'button-select-locator',
  CARD_LOCATOR = 'card-locator',
  CONTEXTUAL_BAR_LOCATOR = 'contextual-bar-locator',
  DECK_LOCATOR = 'deck-locator',
  FETCH_LOCATOR = 'fetch-locator',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_ID = 'field-id',
  FILTER_LOCATOR = 'filter-locator',
  FILTERED_LIST_LOCATOR = 'filtered-list-locator',
  GLOBAL_ACTIONS_LOCATOR = 'global-actions-locator',
  INPUT_DESCRIPTION = 'input-description',
  INPUT_ID = 'input-id',
  LAYOUT_LOCATOR = 'layout-locator',
  MAPPER_LOCATOR = 'mapper-locator',
  PANEL_CARD_LOCATOR = 'panel-card-locator',
  TEXT_CARD_LOCATOR = 'text-card-locator',
}
export { LocatorDcbAliases };
